import {Component} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'unauthorize-page.component',
    templateUrl: 'unauthorize-page.component.html'
})
export class unauthorizePage {
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/unauthorizePage/unauthorize-page.component.ts